import styled from 'styled-components';

export const ErrorContainer = styled.div`
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 8px;

  p {
    font-size: 0.8125rem;
    font-weight: 400;
    line-height: 18px;
    color: #333333;
    margin: 0;
  }
`;

export const ImageWrapper = styled.div`
  width: 120px;

  img {
    max-width: 100%;
  }
`;

export const RetryButton = styled.div`
  font-weight: 600;
  font-size: 13px;
  line-height: 18px;
  color: #00AB6B;
  cursor: pointer;
`;
